<template>
  <!-- 盒子 -->
  <div class="box-div" :class="`entrantsType${entrantsType}`">
    <img
      v-if="imgList.img && ifImg"
      class="tui-img"
      :src="imgList.img"
      alt=""
    />

    <div class="zychoice">
      <!-- 选择xueyuan -->
      <div v-if="showSchool" class="zychoiceTop">
        <div class="zychoiceTopLeft">全部学院：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[!search.school ? 'on' : '']"
            @click="schoolClick()"
          >
            全部
          </div>
          <div
            v-for="(item, ina) in schoollist"
            :key="ina"
            class="right-item"
            :class="search.school == item.pKind ? 'on' : ''"
            @click="schoolClick(item)"
          >
            {{ item.pName }}
          </div>
        </div>
      </div>
      <!-- 选择项目 -->
      <div v-if="(showSchool && search.school) || !showZy" class="zychoiceTop">
        <div class="zychoiceTopLeft">全部项目：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[!search.kind ? 'on' : '']"
            @click="kindClick()"
          >
            全部
          </div>

          <div
            v-for="(item, ina) in kindList"
            :key="ina"
            class="right-item"
            :class="search.kind == item.pKind ? 'on' : ''"
            @click="kindClick(item)"
          >
            {{ item.pName }}
          </div>
        </div>
      </div>
      <!-- 选择层次 -->
      <div
        v-if="
          search.kind &&
          stageList.length > 0 &&
          showLevel &&
          search.examType != 2
        "
        class="zychoiceTop"
      >
        <div class="zychoiceTopLeft">{{ zStage }}：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[search.stage == '全部' ? 'on' : '']"
            @click="stageChoose()"
          >
            全部
          </div>

          <div
            v-for="(item, inb) in stageList"
            :key="inb"
            class="right-item"
            :class="[search.stage == item.stage ? 'on' : '']"
            @click="stageChoose(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 选择省份 -->
      <div
        v-if="
          search.kind &&
          search.examType != 2 &&
          provinceList &&
          provinceList.length
        "
        class="zychoiceTop"
      >
        <div class="zychoiceTopLeft">选择省份：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[!search.areaId ? 'on' : '']"
            @click="provinceChoose()"
          >
            全部
          </div>

          <div
            v-for="(item, inb) in provinceList"
            :key="inb"
            class="right-item"
            :class="[search.areaId == item.provinceId ? 'on' : '']"
            @click="provinceChoose(item, inb)"
          >
            {{ item.provinceName }}
          </div>
        </div>
      </div>
      <!-- 选择专业 -->
      <div
        v-if="search.kind && showZy && search.examType != 2"
        class="zychoiceTop"
      >
        <div class="zychoiceTopLeft">{{ kindZyName }}：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[!search.zyId ? 'on' : '']"
            @click="zyChoose()"
          >
            全部
          </div>

          <div
            v-for="(item, inb) in zylist"
            :key="inb"
            class="right-item"
            :class="[search.zyId == item.zId ? 'on' : '']"
            @click="zyChoose(item)"
          >
            {{ item.zName }}
          </div>
        </div>
      </div>
      <!-- 专业课程 -->
      <!-- <div v-if="search.areaId && showKc && search.zyId" class="zychoiceTop">
        <div class="zychoiceTopLeft">全部课程：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[!search.kcId ? 'on' : '']"
            @click="kcChoose()"
          >
            全部
          </div>
          <div
            v-for="(item, index) in kcList"
            :key="index"
            class="right-item"
            :class="[search.kcId == item.id ? 'on' : '']"
            @click="kcChoose(item)"
          >
            {{ item.kcName }}
          </div>
        </div>
      </div> -->

      <!-- 课程 -->
      <div v-if="type == 117 && courseTypes.length > 0" class="zychoiceTop">
        <div class="zychoiceTopLeft">选择类型：</div>
        <div class="zychoiceTopRight">
          <div
            class="right-item"
            :class="[search.types == '' ? 'on' : '']"
            @click="courseTypesChoose()"
          >
            全部
          </div>
          <div
            v-for="item in courseTypes"
            :key="item.id"
            class="right-item"
            :class="search.types == item.id ? 'on' : ''"
            @click="courseTypesChoose(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import { getDomain } from "@/api/cookies";

export default {
  props: {
    entrantsType: {
      default: 2,
      type: Number,
    },
    showSchool: {
      default: true,
      type: Boolean,
    },
    kind: {
      type: Number,
    },
    zyId: {
      type: Number,
    },
    schoole: {
      type: Number,
    },
    isJinpin: {
      type: Boolean,
      default: true,
    },
    showZy: {
      type: Boolean,
      default: true,
    },
    showKc: {
      type: Boolean,
      default: false,
    },
    type: {
      default: 1,
      type: Number,
    },
    ifImg: {
      type: Boolean,
      default: false,
    },
    showLevel: {
      type: Boolean,
      default: true,
    },
    testPaperType: {
      type: String,
    },
  },
  data() {
    return {
      imgList: {},
      search: {
        school: null,
        schoolName: null,
        type: null,
        name: null,
        examType: 1,
        kind: null,
        stage: "全部",
        zyId: null,
        kcId: null,
        kindName: null,
        stageName: null,
        zyName: null,
        kcName: null,
        productLine: 4, // 精品/普通班型
        types: "", // 课程类型 1直播 2录播 3音频 4 图文 5面授
        kcType: null, // 精品/普通课程
        areaId: null,
      },
      schoollist: [],
      kindList: [],
      stageList: [],
      Kindzylist: [], // 当前项目下的专业
      zylist: [],
      kcList: [], 
      courseTypes: [ 
      ],
      
      kindZyName: "专业名称",
      zStage: "专业阶段",

    
      provinceList: [], // 省份列表
      provinceIndex: null,
    };
  },

  async created() {
    this.domain = getDomain();

    await this.getCourseListTypes();
    homeClient
      .getSurfacePcList({ type: 4, entrantsType: this.domain.entrantsType })
      .then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.imgList = res.data[0];
          } else {
            this.imgList = {};
          }
        }
      });
    if (this.showSchool) {
      await homeClient.getTenantKindNoZyList().then((res) => {
        if (res.code == 0) {
          this.schoollist = res.data;
        }
      });
    }

    
  
    if (this.schoole) {
      for (const item of this.schoollist) {
        if (item.pKind == this.schoole) {
          this.schoolClick(item);
          break;
        }
      }
    }
    if (this.kind) {
      for (const item of this.kindList) {
        if (item.pKind == this.kind) {
          this.kindClick(item);
          break;
        }
      }
    }
    if (this.zyId) {
      for (const item of this.zylist) {
        if (item.zId == this.zyId) {
          this.zyChoose(item);
          break;
        }
      }
    }
   
  },
  methods: {
    /* 学院  */
    async schoolClick(item) {
      if (item) {
        this.search.school = item.pKind;
        this.search.schoolName = item.pName;
        this.kindList = item.kindList;
        this.search.kind = null;
        this.search.kindName = null; 
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.kindZyName = "专业名称";
        this.zStage = "专业阶段";
      } else {
        this.search.school = "";
        this.search.schoolName = "";

        this.search.kind = ""; 
        this.search.kindName = "";
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.zStage = "专业阶段";
        this.kindZyName = "专业名称";
      }
      await this.getCourseListTypes();
      this.getLIst();
    },

    /* 项目选择 */
    async kindClick(item) {
      if (item) {
        this.search.kind = item.pKind;
        this.search.kindName = item.pName;

        this.stageList = item.pStage ? JSON.parse(item.pStage) : [];
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.stage = "全部";
        this.search.stageName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.provinceList = [];
       

        this.zylist = item.zyList;
        this.Kindzylist = item.zyList;
      } else {
        this.search.kind = "";
        this.zylist = [];
        this.Kindzylist = [];
        this.stageList = [];
        this.provinceList = [];
        this.search.kindName = "";
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.stage = "全部";
        this.search.stageName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.zStage = "专业阶段";
        this.kindZyName = "专业名称";
      }
      await this.selectProvinceVoList();
      await this.getCourseListTypes();
      this.getKc();
      this.getLIst();
    },
    /* 层次选择 */
    async stageChoose(item) {
      if (item) {
        this.search.stage = item.stage;
        this.search.stageName = item.name;
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.provinceList = [];

        await this.selectProvinceVoList();
        if (this.provinceIndex || this.provinceIndex == 0) {
          this.zylist = this.provinceList[this.provinceIndex].zyList;
        }
      } else {
        this.search.stage = "全部";
        await this.selectProvinceVoList();
        if (this.provinceIndex || this.provinceIndex == 0) {
          this.zylist = this.provinceList[this.provinceIndex].zyList;
        } else {
          this.zylist = this.allZyList;
        }

        this.search.stage = "全部";
        this.search.stageName = "";
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.provinceList = [];
      }
      await this.getCourseListTypes();
    },
    async getCourseListTypes() {
      return homeClient
        .getCourseListTypes({ 
          belongCollege: this.search.school ? this.search.school : undefined,
          belongProject	: this.search.kind ? this.search.kind : undefined,
          belongMajor: this.search.zyId ? this.search.zyId : undefined,
          belongCourseTitle: this.search.kcId ? this.search.kcId : undefined,
          areaId: this.search.areaId ? this.search.areaId : undefined,
        })
        .then((res) => {
          this.courseTypes = res.code == 0 && Array.isArray(res.data) ? res.data : [];
        });
    },
    /* 专业选择 */
    async zyChoose(item) {
      if (item) {
        this.search.zyId = item.zId;
        this.search.zyName = item.zName;
        this.search.kcId = "";
        this.search.kcName = "";
        if (this.showKc) {
          this.getKc();
        }
      } else {
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
      }
      await this.getCourseListTypes();
      this.getLIst();
    },
    /* 省份列表 */
    async selectProvinceVoList() {
      const data = {
        belongCollege: this.search.school,
        belongProject: this.search.kind,
        stage: this.search.stage == "全部" ? "" : this.search.stageName,
      }
      if(this.type==117){
 await homeClient.getTenantBoutiqueProvinceList(data).then((res) => {
        this.provinceList = res.data.provinceVoList;
        this.zylist = res.data.zyList;
        this.allZyList = res.data.zyList;
        if (this.zyId) {
          for (const item of this.zylist) {
            if (item.zId == this.zyId) {
              this.zyChoose(item);
              break;
            }
          }
        }
      });
      }else{
 await homeClient.getTenantBoutiqueProvinceList(data).then((res) => {
        this.provinceList = res.data.provinceVoList;
        this.zylist = res.data.zyList;
        this.allZyList = res.data.zyList;
        if (this.zyId) {
          for (const item of this.zylist) {
            if (item.zId == this.zyId) {
              this.zyChoose(item);
              break;
            }
          }
        }
      });
      }
     
    },
    // 省份选择
    async provinceChoose(item, index) {
      this.provinceIndex = index;
      this.search.zyId = "";
      this.search.zyName = "";
      if (item) {
        this.search.areaId = item.provinceId;
        this.zylist = item.zyList;
      } else {
        this.search.areaId = "";
        this.zylist = this.allZyList;
      }
      await this.getCourseListTypes();
      this.getKc();
      this.getLIst();
    },
   
    getKc() {
      homeClient
        .selectProvinceKechengList({
          zyId: this.search.zyId,
          provinceIds: this.search.areaId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.kcList = res.data;
          } else {
            this.kcList = [];
          }
        });
    },
    /* 课程选择 */
    async kcChoose(item) {
      if (item) {
        this.search.kcId = item.id;
        this.search.kcName = item.kcName;
      } else {
        this.search.kcId = "";
        this.search.kcName = "";
      }
      await this.getCourseListTypes();
      this.getLIst();
    },
  

    courseTypesChoose(val) {
      if (val) {
        // 接口使用 id 标识课程类型：1 为直播课，2 为录播课。
        this.search.types = val.id;
      } else {
        this.search.types = "";
      }
      this.getLIst(1);
    },
    /* 清空搜索 */
    changeList() {
      this.search.school = null;
      this.search.schoolName = null;
      this.search.type = null;
      this.search.kind = null;
      this.search.stage = "全部";
      this.search.zyId = null;
      this.search.kcId = null;
      this.search.kindName = null;
      this.search.stageName = null;
      this.search.zyName = null;
      this.search.kcName = null;
      this.search.productLine = 4; // 精品/普通班型
      this.search.kcType = null; // 精品/普通课程
      this.getTabList(); 
    },
    getLIst(i) {
      if (!i) {
        this.getCourseListTypes();
      }

      this.$nextTick(() => {
        this.$emit("isOk", this.search);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/* 高校合伙人 */
.entrantsType3 {
  .zychoice {
    width: 1200px !important;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: 40px auto 24px;
    padding: 20px 32px 40px;

    .on {
      background: #f1f4ff !important;
      color: #4a6af0 !important;
    }
  }
}

.box-div {
  width: 100%;
  margin: 0px auto 0px;
}

.tui-img {
  width: 100%;
  height: 240px;
}

.zychoice {
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 6px 0px rgba(216, 216, 216, 0.7);
  background: #ffffff;
  overflow: visible;
  padding: 0px calc(50% - 610px) 32px;

  .zychoicePzion {
    width: 100%;
    background: #ffffff;
    height: 60px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-breadcrumb {
      font-size: 15px;
      cursor: pointer;
    }
  }

  .zychoiceTop {
    width: 100%;
    background: #ffffff;
    padding-top: 20px;
    // height: 70px;
    height: auto;
    // border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 30px;

    &:nth-child(1) {
      .right-item {
       // font-size: 16px !important;
      }
    }

    .zychoiceTopLeft {
      flex-shrink: 0;
    }

    .zychoiceTopRight {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;

      .right-item {
        height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding: 0px 16px;
        cursor: pointer;
      }

      .on {
        background: #f5f6f6;
        border-radius: 4px 4px 4px 4px;
        color: #ff5d51;
      }
    }
  }

  .zychoiceCen {
    width: 90%;
    height: 64px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .spana {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 53px;
      cursor: pointer;
    }

    .spanb {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanbs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanc {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 30px;
      cursor: pointer;
    }

    .spancs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 30px;
      cursor: pointer;
    }
  }
}

.tabBox {
  width: 1220px;
  margin: auto;
  margin-top: 40px;

  .list {
    display: flex;

    .item {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 14px;

      .el-divider {
        margin: 0px 24px;
      }
    }

    .on {
      color: #ff5e51 !important;
    }
  }
}
</style>
